import { client } from "api/client";
import * as actions from "modules/common/store/actions";
import * as utility from "utilities/utils";
import { ENDPOINTS } from "utilities/endPoints";
import commonUtilities from "utilities/common";

export default function getFlightsDates(params) {
    return async (dispatch) => {

        let brand = "";
        if(commonUtilities.isCalculatedQuote()) {
            brand = `&brand=${process.env.REACT_APP_BRAND}`;
        }
        const url = `${process.env.REACT_APP_SEARCH_API}${ENDPOINTS.SEARCH_API.FLIGHTS_DATES}`;
        dispatch({
            type: actions.GET_FLIGHTS_DATES_RESET
        });

        try {
            const departureResponse = await client.get(`${url}/${params.lang}?dep=${params.departure}&arr=${params.arrival}&dur=${params.duration}${brand}`);

            const returnResponse = await client.get(`${url}/${params.lang}?dep=${params.arrival}&arr=${params.departure}&dur=${params.duration}${brand}`);

            dispatch({
                type: actions.GET_FLIGHTS_DATES_SUCCESS,
                payload: {
                    data: {
                        departureDate: departureResponse,
                        returnDate: returnResponse
                    }
                }
            });
        } catch (error) {
            dispatch({
                type: actions.GET_FLIGHTS_DATES_FAIL,
                payload: utility.getErrorResponse(error)
            });
        }
    };
}
